import { persist, createCookieStorage } from '@macfja/svelte-persistent-store';
import { writable } from 'svelte/store';

export const userLocale = persist(writable('en'), createCookieStorage(), 'userLocale');

export const setLocale = (locale: string) => {
	const trimmedLocale = locale.trim();
	userLocale.update(() => trimmedLocale);
};
